export default "__VITE_ASSET__kcsI09xd__"